import { logger as e } from "./logger.mjs";
//#region src/core/EventQueue.ts
var t = "maat_queue_", n = 1e3, r = class {
	constructor(e, r, i, a = n) {
		this.adapter = r, this.eventTTL = i, this.capacity = a, this.inMemoryBuffer = [], this.storageKey = `${t}${e}`;
	}
	async hydrate() {
		this.inMemoryBuffer = (await this.readEntry(this.storageKey)).events;
	}
	async enqueue(t) {
		if (this.inMemoryBuffer.push(t), this.inMemoryBuffer.length > this.capacity) {
			let t = this.inMemoryBuffer.length - this.capacity;
			this.inMemoryBuffer.splice(0, t), e.warn("queue at capacity, dropped oldest events", t);
		}
		await this.persist();
	}
	async snapshot() {
		return [...this.inMemoryBuffer];
	}
	async remove(e) {
		let t = new Set(e.map((e) => e.id));
		this.inMemoryBuffer = this.inMemoryBuffer.filter((e) => !t.has(e.id)), this.inMemoryBuffer.length === 0 ? await this.adapter.delete(this.storageKey) : await this.persist();
	}
	async clear() {
		this.inMemoryBuffer = [], await this.adapter.delete(this.storageKey);
	}
	async touch() {
		this.inMemoryBuffer.length !== 0 && await this.persist();
	}
	size() {
		return this.inMemoryBuffer.length;
	}
	async reapOrphans(t) {
		let n = Date.now(), r = await this.adapter.listKeys(t);
		for (let t of r) {
			if (t === this.storageKey) continue;
			let { lastSeen: r, events: i } = await this.readEntry(t);
			(i.length === 0 || n - r > this.eventTTL) && (await this.adapter.delete(t), e.debug("reaped orphan queue key", t, `(${i.length} events)`));
		}
	}
	async persist() {
		let e = {
			lastSeen: Date.now(),
			events: this.inMemoryBuffer
		};
		await this.adapter.write(this.storageKey, JSON.stringify(e));
	}
	async readEntry(t) {
		let n = await this.adapter.read(t);
		if (!n) return {
			lastSeen: 0,
			events: []
		};
		try {
			let e = JSON.parse(n);
			return Array.isArray(e) ? {
				lastSeen: 0,
				events: e
			} : e && Array.isArray(e.events) ? {
				lastSeen: typeof e.lastSeen == "number" ? e.lastSeen : 0,
				events: e.events
			} : {
				lastSeen: 0,
				events: []
			};
		} catch {
			return e.warn("corrupt queue payload, discarding", t), {
				lastSeen: 0,
				events: []
			};
		}
	}
};
//#endregion
export { n as DEFAULT_CAPACITY, r as EventQueue, t as QUEUE_KEY_PREFIX };
